/** Inches-to-centimeters factor (ESN / OLS `CM_IN_INCH`). */
export const IN_TO_CM = 2.54;

/** Centimeters-to-inches factor (ESN / OLS `INCH_IN_CM`). */
export const CM_TO_IN = 0.3937;

/**
 * Converts inches to centimeters using ESN `convertInchesToCM` rounding.
 * Applies `.toFixed(2)`, then adds 0.01 when the round-trip via 0.3937 equals the input inches
 * so dual-unit max labels stay inclusive (e.g. 108 in → 274.33 cm).
 */
export function convertInchesToCM(inches: number): number {
  let cm = Number((inches * IN_TO_CM).toFixed(2));
  if (Number((cm * CM_TO_IN).toFixed(2)) === inches) {
    cm = Number((cm + 0.01).toFixed(2));
  }
  return cm;
}

/**
 * Converts a metric dimension to the whole-inch value used by the current ESN validation.
 * Any fractional inch rounds up, so 274.33 cm becomes 109 in while 274.32 cm remains 108 in.
 */
export function roundUpCentimetersToWholeInches(cm: number): number {
  return Math.ceil(cm / IN_TO_CM);
}
